/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateWarehouseInventoryProductDto = {
  /**
   * Associated product ID
   */
  productId: number;
  /**
   * Unique product code
   */
  productCodeUnique: string;
  /**
   * Associated location ID
   */
  locationId: number;
  /**
   * Associated inventory record item ID
   */
  inventoryRecordItemId: number;
  /**
   * Supplier ID for this warehouse inventory product
   */
  supplierId?: number;
  /**
   * Product status
   */
  status: CreateWarehouseInventoryProductDto.status;
  /**
   * Status of the product in warehouse inventory
   */
  availabilityStatus: CreateWarehouseInventoryProductDto.availabilityStatus;
  /**
   * Transferred to branch flag
   */
  transferredToBranch?: boolean;
  /**
   * Specific weight in grams for this item
   */
  weightGrams?: number;
  /**
   * Specific length in millimeters for this item
   */
  lengthMm?: number;
  /**
   * Talla para esta unidad (diameterSize)
   */
  diameterSize?: string;
  /**
   * Specific properties description for this item
   */
  propertiesDescription?: string;
  /**
   * Current condition of the item
   */
  condition?: string;
  /**
   * Specific notes for this individual item
   */
  itemNotes?: string;
  /**
   * Specific color for this item
   */
  color?: string;
  /**
   * Color ID for this specific unit
   */
  colorId?: number;
  /**
   * Specific workshop code for this item
   */
  workshopCode?: string;
  /**
   * Material ID for this specific unit
   */
  materialId?: number;
  /**
   * Cost price for this specific unit
   */
  costPrice?: number;
  /**
   * Sale price for this specific unit
   */
  salePrice?: number;
};
export namespace CreateWarehouseInventoryProductDto {
  /**
   * Product status
   */
  export enum status {
    UNASSIGNED = 'UNASSIGNED',
    IN_TRANSIT = 'IN_TRANSIT',
    ASSIGNED = 'ASSIGNED',
  }
  /**
   * Status of the product in warehouse inventory
   */
  export enum availabilityStatus {
    AVAILABLE = 'AVAILABLE',
    SOLD = 'SOLD',
    RESERVED = 'RESERVED',
    PARTIAL_PAYMENT = 'PARTIAL_PAYMENT',
  }
}
